import React from 'react'
import { useCheckoutUI } from 'src/lib/contexts/CheckoutUIContext'

interface CouponCardPreviewProps {
  id?: string
  identifier: string
  descTitle: string | null
  desc: string | null
  longDesc: string
  hideApply?: boolean
  hideLongDesc?: boolean
}

const CouponCardPreview: React.FC<CouponCardPreviewProps> = ({
  identifier,
  descTitle,
  desc,
  longDesc,
  hideLongDesc = false
}) => {
  const {
    getters: { checkoutUI }
  } = useCheckoutUI()

  const themeColor = checkoutUI?.colorPalette?.primaryColor?.substring(0, 7) || '#000000'
  const backgroundImage = `linear-gradient(180deg, ${themeColor}1A, transparent)`

  return (
    <div className='flex flex-col h-fit w-full max-w-[400px] rounded-[18px] bg-white overflow-hidden shadow-sm'>
      {/* Header */}
      <div className='flex items-center justify-between p-4 px-3 rounded-[16px] ' style={{ backgroundImage }}>
        <div className='flex items-center gap-2.5 w-[360px] overflow-hidden'>
          <div
            className='h-6 w-6 shrink-0'
            style={{
              backgroundColor: themeColor,
              maskImage: 'url(/images/coupon.svg)',
              maskRepeat: 'no-repeat',
              maskPosition: 'center',
              WebkitMaskImage: 'url(/images/coupon.svg)',
              WebkitMaskRepeat: 'no-repeat',
              WebkitMaskPosition: 'center'
            }}
          />
          <span className='text-base font-semibold text-zinc-900 truncate w-full'>{identifier}</span>
        </div>
      </div>

      {(descTitle || desc) && (
        <div className='flex flex-col items-start gap-0.5 px-3 py-2'>
          {descTitle && (
            <span className='text-base font-semibold text-zinc-900 w-full truncate pointer-events-none'>
              {descTitle}
            </span>
          )}
          {desc && <span className='text-sm text-[#6E6E6E] leading-4 w-full pointer-events-none'>{desc}</span>}
        </div>
      )}

      {!hideLongDesc && longDesc && longDesc.trim().length > 0 && (
        <div className='bg-gray-lighter rounded-lg p-2 m-3 mt-4'>
          <ul className='flex flex-col gap-1'>
            {longDesc
              .split('\n')
              .filter(point => point.trim() !== '')
              .map((point, index) => (
                <li key={`${point}_${index}`} className='flex items-start gap-2 text-zinc-700 p-0'>
                  <div className='w-1 h-1 rounded-full bg-zinc-400 mt-1.5 shrink-0' />
                  <span className='text-text-xs-medium'>{point}</span>
                </li>
              ))}
          </ul>
        </div>
      )}
    </div>
  )
}

export default CouponCardPreview
